import firebase from 'firebase';

const storageRef = firebase.storage().ref();

export function upload(ref, file, progressCallback) {
  return new Promise((resolve, reject) => {
    const fileRef = storageRef.child(ref);

    const metadata = {
      cacheControl: 'public,max-age=2678400', // 1 month
    };

    const task = typeof file === 'string' && file.indexOf('data:') === 0 ?
      fileRef.putString(file, 'data_url', metadata) : fileRef.put(file, metadata);

    task.on('state_changed', (snapshot) => {
      if (progressCallback) {
        const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        progressCallback(progress);
      }
    }, reject, () => task.snapshot.ref.getDownloadURL().then(resolve));
  });
}

export function remove(ref) {
  return storageRef.child(ref).delete();
}

export function cache(ref) {
  const metadata = {
    cacheControl: 'public,max-age=2678400', // 1 month
  };

  return storageRef.child(ref).updateMetadata(metadata);
}



// WEBPACK FOOTER //
// ./src/firebase/repositories/storage.js